export const LOGIN = 'LOGIN';
export const LOGIN_AS_ADMIN = 'LOGIN_AS_ADMIN';
export const LOGOUT = 'LOGOUT';
export const MODULE_LOADED = 'MODULE_LOADED';
